import Checkbox from './Checkbox';
export default Checkbox;


// WEBPACK FOOTER //
// ./src/packages/Checkbox/index.js